import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <span className="footer-logo">⚡ React Tools</span>
            <p className="footer-tagline">
              Free online tools for developers, built with React.
            </p>
          </div>
          <div className="footer-links">
            <Link to="/" className="footer-link">Home</Link>
            <Link to="/tools" className="footer-link">All Tools</Link>
          </div>
        </div>
        <div className="footer-bottom">
          <p className="copyright">
            © {currentYear} React Tools. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
